import {IServiceFactory} from "../../../service-factory.interface";
import {OnlineCheckInBlockerSsr} from "../online-check-in-blocker-ssr";
import {TimeSpan} from "../../../../types/time-span";

export default class DepaSsrType extends OnlineCheckInBlockerSsr {
    constructor(services: IServiceFactory) {
        super('DEPA', services);
    }

    protected _getPurchaseMinimumTimeBeforeFlight(): TimeSpan | null {
        return TimeSpan.fromHours(24);
    }
}
